module.exports = __webpack_public_path__ + "01636639f3b0d309f7689331136c7ef6.png";